import React from "react";
import { ActivityIndicator } from "react-native";
import Box from "../Box";
import Stack from "../Stack";
import Typography from "../Typography";
import Button from "../OldButton";
import Spacer from "../Spacer";
// import Icon from "../Icon";

interface PropTypes {
  onAdd?: () => void;
  onRemove?: () => void;
  coupon?: string;
  loading?: boolean;
  theme?: {
    main?: string;
  };
  workspace?: {
    id: string;
    logo: string;
    name: string;
    agreement?: {
      promotion_code?: string;
    };
  };
}

function SetCouponBox(props: PropTypes) {
  let hasBeenSet = !!props.coupon;
  let mainColor = props?.theme?.main || "secondary";
  let bgColor = `${mainColor}.dark`;

  if (hasBeenSet) {
    if (
      props.workspace &&
      props.workspace.id != "personal" &&
      props.workspace.agreement &&
      props.workspace.agreement.promotion_code
    ) {
      return (
        <Box bg={bgColor} p="l" br="m">
          <Stack>
            <Typography fs="s" color="common.white">
              کد تخفیف گروه
            </Typography>
            <Spacer size="m" />
            <Typography fs="m" ff="mainBold" color="common.white">
              {props.workspace.name}
            </Typography>
            <Spacer size="m" />
            <Typography fs="s" color="common.white">
              برای شما اعمال شده است.
            </Typography>
          </Stack>
        </Box>
      );
    }
    return (
      <Box bg={bgColor} p="l" br="m">
        <Stack distribution="space-between">
          <Stack>
            <Stack direction="vertical" alignment="end">
              <Typography fs="s" color="common.white">
                کد تخفیف
              </Typography>
              <Typography fs="m" ff="mainBold" color="common.white">
                {props.coupon}
              </Typography>
            </Stack>

            {props.loading && (
              <>
                <Spacer size="m" />
                <ActivityIndicator />
              </>
            )}
          </Stack>

          <Button onPress={props.onRemove}>
            <Stack>
              {/* <Icon name="trash" size={16} color="common.white" /> */}
              <Spacer size="m" />
              <Typography fs="xm" ff="mainBold" color="common.white">
                حذف کد
              </Typography>
            </Stack>
          </Button>
        </Stack>
      </Box>
    );
  }

  // It should be here and after checkin "remove mode"
  if (!props.onAdd) {
    return (
      <Box bg="neutrals.700" p="l" br="m">
        <Stack distribution="center">
          <Typography fs="m" ff="mainBold" color="common.white">
            امکان ثبت کد تخفیف وجود ندارد.
          </Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <Box bg={bgColor} p="l" br="m">
      <Button onPress={props.onAdd}>
        <Stack distribution="space-between">
          <Stack>
            {/* <Icon name="percent" size={24} />
          <Spacer size="m" /> */}
            <Typography fs="m" ff="mainBold" color="common.white">
              کد تخفیف دارید؟
            </Typography>
            {props.loading && (
              <>
                <Spacer size="m" />
                <ActivityIndicator />
              </>
            )}
          </Stack>

          <Stack>
            {/* <Icon name="plus" size={16} color="common.white" /> */}
            <Typography fs="xm" ff="mainBold" color="common.white">
              افزودن کد تخفیف
            </Typography>
          </Stack>
        </Stack>
      </Button>
    </Box>
  );
}

export default SetCouponBox;
